
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.25","height":"34.5","viewBox":"0 0 23.25 34.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.75 34.5c-.79 0-1.58-.21-2.31-.64C0 24.02 0 19.6 0 17.94 0 16.33 0 12.06 16.18.81c2.04-1.42 4.84-.92 6.26 1.12s.92 4.84-1.12 6.26c-4.89 3.41-9.78 7.47-11.72 9.66 1.96 1.97 6.73 5.45 11.46 8.29a4.506 4.506 0 011.55 6.17 4.483 4.483 0 01-3.86 2.19z"}})])
          )
        }
      }
    